import { Routes, Route } from 'react-router-dom';
import { Header } from '@/components/layout/header';
import { Home } from '@/pages/home';
import { About } from '@/pages/about';
import { Pricing } from '@/pages/pricing';
import { Launch } from '@/pages/launch';
import { Output } from '@/pages/output';
import { NewOutput } from '@/pages/newoutput';
import { ResetPasswordPage } from '@/pages/auth/reset-password';
import { VerifyHandler } from './components/auth/verify-handler';
import YouTubeServiceTest from '@/components/test/YouTubeServiceTest';
import { ThemeProvider } from './components/theme/theme-provider';
import { Toaster } from 'sonner';
import { ProtectedRoute } from '@/components/auth/protected-route';
import TagManager from 'react-gtm-module';
import { useEffect } from 'react';

export default function App() {
  useEffect(() => {
    TagManager.initialize({
      gtmId: 'GTM-K64WVX4R',
      dataLayer: {
        platform: 'web',
        environment: import.meta.env.MODE
      }
    });
  }, []);

  return (
    <ThemeProvider>
      <div className="min-h-screen bg-surface-50 transition-colors duration-300 dark:bg-dark-bg">
        <Header />
        <main className="container mx-auto pt-20">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/launch" element={<Launch />} />
            <Route path="/output" element={<Output />} />
            <Route 
              path="/newoutput" 
              element={
                <ProtectedRoute>
                  <NewOutput />
                </ProtectedRoute>
              } 
            />
            <Route path="/auth/reset-password" element={<ResetPasswordPage />} />
            <Route path="/auth/verify" element={<VerifyHandler />} />
            <Route path="/test/youtube" element={<YouTubeServiceTest />} />
          </Routes>
        </main>
        <Toaster />
      </div>
    </ThemeProvider>
  );
}